
import { defineComponent } from 'vue'

// buttonType: main, secondary, text, icon
// buttonSize: m, s, xs(only text)
// iconName: if not specified, it will not be drawn

export default defineComponent({
  name: 'AppButton',
  emits: ['button-click'],
  props: {
    buttonType: String,
    buttonSize: String,
    buttonText: String,
    isActive: Boolean,
    isDisabled: Boolean,
    iconName: String,
    buttonStyle: String
  },
  data() {
    return {
      colorFill: '#ffffff'
    }
  },
  methods: {
    getIconSize() {
      if (this.buttonSize === 'm') {
        return 15
      }
      if (this.buttonSize === 's') {
        return 12
      }
      if (this.buttonSize === 'xs') {
        return 8
      }
    },
    onButtonClick(event: Event) {
      this.$emit('button-click', event)
    },
    initColorFill(): string {
      if (this.buttonType === 'main') {
        return '#ffffff'
      }
      if (this.buttonType === 'secondary') {
        return '#AFBBC4'
      }
      if (this.buttonType === 'text') {
        return '#cdd5da'
      }
      if (this.buttonType === 'icon' && !this.isActive) {
        return '#AFBBC4'
      }
      if (this.buttonType === 'icon' && this.isActive) {
        return '#FFFFFF'
      }
      //default
      return '#FFFFFF'
    },
    iconColorFillOver() {
      if (this.buttonType === 'secondary') {
        this.colorFill = '#56889F'
      }
      if (this.buttonType === 'text') {
        this.colorFill = '#cdd5da'
      }
      if (this.buttonType === 'icon' && !this.isActive) {
        this.colorFill = '#666F75'
      }
    },
    iconColorFillLeave() {
      if (this.buttonType === 'secondary') {
        this.colorFill = '#AFBBC4'
      }
      if (this.buttonType === 'text') {
        this.colorFill = '#666F75'
      }
      if (this.buttonType === 'icon' && !this.isActive) {
        this.colorFill = '#AFBBC4'
      }
    }
  },
  mounted() {
    this.colorFill = this.initColorFill()
  }
})
